<template lang="pug">
.v-atm-card.atm-card.no-scrollbar(v-if="card" :id="card?.id")
	.atm-card__categories(v-if="card.category||card.workStatus")
		.atm-card__category(v-if="card.category" v-for="category in card.category") {{category.text}}
		.atm-card__category.sticker--top(v-if="card.workStatus") {{card.workStatus}}
	.atm-card__title(v-if="card.title") {{card.title}}
	.atm-card__text(v-if="card.text") {{card.text}}
	.atm-card__sections(v-if="card.items")
		.atm-card__section(v-for="(section, sectionIndex) in card.items" :class="[section.collapse ? 'atm-card__section--clickable' : '', section.open ? 'open' : '']" :key="sectionIndex")
			.atm-card__section-head(@click="toggleItem(section, $event)")
				v-svg-icon.atm-card__section-icon(v-if="section.icon" :icon="section.icon")
				span.atm-card__section-title(v-if="section.title") {{section.title}}
				v-svg-icon.atm-card__section-arrow(v-if="section.collapse" icon="dropdown")
			.atm-card__section-body-wrap(:class="{'atm-card__section-body-wrap--shown': !section.collapse}")
				.atm-card__section-body
					.atm-card__tags(v-if="section.tags")
						.atm-card__tag(v-for="tag in section.tags") {{tag.text}}
					.atm-card__tables(v-if="section.items")
						.atm-card__table(v-for="table in section.items")
							.atm-card__table-title(v-if="table.title") {{table.title}}
							.atm-card__table-body(v-if="table.items")
								.atm-card__table-row(v-for="row in table.items")
									.atm-card__table-label(v-if="row.label" :style="{color: row.label.color}") {{row.label.text}}
									.atm-card__table-value(v-if="row.value" :style="{color: row.value.color}")
										component(:is="row.value.bold ? 'b' : 'span'") {{row.value.text}}
							.atm-card__note(v-if="table.note" v-html="table.note")
					.atm-card__text(v-if="section.text" v-html="section.text")
</template>

<script>

export default {

	props: {
		card: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
		}
	},

	watch: {
		card() {
			this.$nextTick(() => {
				this.closeItems();
				this.setHeights();
			});
		}
	},

	created() {
		this.$nextTick(() => {
			this.closeItems();
			this.setHeights();
		});
	},

	methods: {
		closeItems() {
			this.card.items.forEach(item => {
				item.open = false;
			});
			let $sectionBodyWraps = this.$el.querySelectorAll('.atm-card__section-body-wrap');
			if ($sectionBodyWraps && $sectionBodyWraps.length) {
				$sectionBodyWraps.forEach($sectionBodyWrap => {
					this.setHeight($sectionBodyWrap, 0);
				});
			}
		},

		getNext(el, selector) {
			const nextEl = el.nextElementSibling;
			if (!selector || (nextEl && nextEl.matches(selector))) {
				return nextEl;
			}
			return null;
		},

		setHeight(el, val) {
			if (typeof val === 'function') val = val();
			if (typeof val === 'string') el.style.height = val;
			else el.style.height = val + 'px';
		},

		setHeights() {
			let $sectionBodies = this.$el.querySelectorAll('.atm-card__section-body');
			if ($sectionBodies && $sectionBodies.length) {
				$sectionBodies.forEach($sectionBody => {
					$sectionBody.setAttribute('data-height', $sectionBody.getBoundingClientRect().height);
				});
			}
		},

		toggleItem(section, e) {
			if (section.collapse) {
				let $sectionBodyWrap = this.getNext(e.currentTarget);
				let height = +$sectionBodyWrap.querySelector('.atm-card__section-body').getAttribute('data-height');
				if (section.open) {
					this.setHeight($sectionBodyWrap, 0);
					section.open = false;
				} else {
					this.setHeight($sectionBodyWrap, height);
					section.open = true;
				}
			}
		},
	}
}

</script>